import PkLoaderController from './pk.loader.controller';
import template from './pk.loader.html';
import './pk.loader.scss';

class PkLoaderComponent {
    /*@ngInject*/
    constructor() {
        _.extend(this, {
            name: 'PkLoader',
            template: template,
            restrict: 'A',
            transclude: true,
            scope: {},
            controller: PkLoaderController,
            controllerAs: 'loader',
            bindToController: PkLoaderController.bindings
        });
    }
}

export default PkLoaderComponent;


// WEBPACK FOOTER //
// ./client/app/common/pk.loader.component/pk.loader.component.js